import React from 'react';

import PropTypes from 'prop-types';
import { SocialIcons } from 'C4';

const ContentHeader = (props) => {
  const {
    header, subtitle, social, line,
  } = props;

  return (
    <div className="contentHeader" id="contentHeader">
      <h3>{header}</h3>
      <h6>{subtitle}</h6>
      {line && <div className="line" />}
      {props.children}
      {social && <SocialIcons />}
    </div>
  );
};

export default ContentHeader;

ContentHeader.propTypes = {
  header: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  social: PropTypes.bool,
  line: PropTypes.bool,
};

ContentHeader.defaultProps = {
  header: 'CONTENT HEADER',
  subtitle: '',
  children: null,
  social: false,
  line: false,
};
